import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Conditional } from '@resurs/react-utils'
import { getText } from '../../internal/TextLabels'

const CreditSlider = ({ values, onChange }) => {
  const [value, setValue] = useState(0)
  const [disclaimer, setDisclaimer] = useState(false)

  useEffect(() => setValue(0), [values])
  useEffect(
    () => {
      if (values && values.length) {
        onChange(values[value])
        setDisclaimer(values[value].lowestMonthlyCost)
      }
    },
    [value],
  )

  const onValueChange = e => {
    setValue(e.target.value)
  }

  if (values.length <= 1) {
    return null
  }
  return (
    <div style={{ padding: '1em 0 1em 0', width: '100%' }}>
      <div>
        <input
          style={{ width: '100%' }}
          type="range"
          id="start"
          name="creditRange"
          min="0"
          max={values.length - 1}
          step="1"
          onChange={onValueChange}
          value={value}
        />
      </div>
      <div style={{ display: 'flex', fontSize: '2rem', marginTop: '1rem' }}>
        <div style={{ flex: '50%' }}>
          {`${(values[0] && values[0].months) || ''}
            ${getText('default.nonAbbrivations.months')}`}
        </div>
        <div style={{ flex: '50%', textAlign: 'right' }}>
          {`${values[values.length - 1].months || ''}
            ${getText('default.nonAbbrivations.months')}`}
        </div>
      </div>
      <Conditional when={disclaimer}>
        <span style={{ color: 'red' }}>
          {getText('payApply.priceSignageCost.disclaimer')}
        </span>
      </Conditional>
    </div>
  )
}

CreditSlider.propTypes = {
  values: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default CreditSlider
